import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { saveDashboardFeedback } from "seneca-common/features/feedback/actions/service";
import useLocationOnMount from "seneca-common/utils/hooks/routing/useLocationOnMount";

import { WarningModalWithTheme } from "features/common/components/WarningModal";
import ImageVideo from "features/common/imageComponents/components/ImageVideo";
import { makeFeedbackModal } from "features/feedback";
import { makeLinkToSignIn } from "features/sign-up/global-sign-up-modal/links";
import { signOut } from "features/user";

import styles from "./CredentialsExpiredModal.module.scss";
import { useFailGif } from "./utils";

const FeedbackModal = makeFeedbackModal({
  formName: "dashboard",
  saveFeedbackAction: saveDashboardFeedback
});

export default function CredentialsExpiredModal() {
  const failGif = useFailGif();
  const [givingFeedback, setGivingFeedback] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocationOnMount();

  const onClick = async () => {
    await dispatch(signOut());

    history.push(
      makeLinkToSignIn("", {
        redirectAuthenticatedUserToLocation: location.pathname
      })
    );
  };

  return givingFeedback ? (
    <FeedbackModal
      feedbackId="credentialsExpired"
      successButtonText="Back"
      onCloseClick={() => setGivingFeedback(false)}
      onSubmitSuccess={() => setGivingFeedback(false)}
    />
  ) : (
    <WarningModalWithTheme
      title="Your session has expired!"
      subTitle="According to our system it's been a long time since you last logged in, so we're going to need you to log back in to prove you're still you!"
      buttonText="Log in again"
      onPrimaryButtonClick={onClick}
      clickToExit={false}
      // @ts-ignore
      renderInnerOnly
      cancelButton
      onCancelClick={() => setGivingFeedback(true)}
      cancelButtonText="Does this keep happening? Let us know!"
    >
      {/* @ts-ignore */}
      <ImageVideo
        elementClassName={styles.failGif}
        src={failGif as any}
        maxHeight={250}
        margin={20}
      />
    </WarningModalWithTheme>
  );
}
